import { Component, OnInit, Inject, Injector } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

import {
  UserProfile
} from '../../models';

import { LoginResult, ADPResourceService as ResourceService, SnackBarData } from 'digital-core';
import { TokenService } from '../../services';
//import { LoginService } from '../../services/login.service';
import { LogoutService } from '../../services/logout.service';
import { LogoutBehaviorService } from '../../services/logout-behavior.service';

@Component({
  selector: "unauthorized-snack-bar-body",
  templateUrl: "./unauthorized-snack-bar-body.component.html",
  styleUrls: ["./unauthorized-snack-bar-body.component.css"]
})
export class UnauthorizedSnackBarBodyComponent implements OnInit {
  loginResult: LoginResult;
  userProfile: UserProfile;
  webApiUrl: string;

  constructor(public resourceService: ResourceService, public logoutService: LogoutService, private logoutBehaviorService: LogoutBehaviorService,
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackBarData,
    private injector: Injector,
    private dialogRef: MatDialog,
    private tokenService: TokenService) {
  }

  ngOnInit() {
    this.logoutBehaviorService.resetStatus();
  }

  externalLogout() {
    this.logoutService.logout(this.data.Parameters, true).subscribe(() => {
      window.location.reload();
    })
  }


  logout() {
    const currentLoginInfo = this.tokenService.getCurrentUserInfo();
    if (currentLoginInfo) {
      this.logoutService.logout(currentLoginInfo.Email, true).subscribe(() => {
        localStorage.removeItem("login_info");
        localStorage.removeItem("dealerShip_info");
        localStorage.removeItem("local_resources_menu_Portal_Left_Menu");
        localStorage.removeItem("token_info");
        localStorage.removeItem("user_preference");
        this.loginResult = null;
        this.dialogRef.closeAll();
        //let loginService = this.injector.get(LoginService);
        //loginService.signOut();
      }, (() => {
        localStorage.removeItem("login_info");
        localStorage.removeItem("dealerShip_info");
        localStorage.removeItem("local_resources_menu_Portal_Left_Menu");
        localStorage.removeItem("token_info");
        localStorage.removeItem("user_preference");
      }));
    } else {
      localStorage.removeItem("login_info");
      localStorage.removeItem("dealerShip_info");
      localStorage.removeItem("local_resources_menu_Portal_Left_Menu");
      localStorage.removeItem("token_info");
      localStorage.removeItem("user_preference");
    }

    this.logoutBehaviorService.setStatus(true);

  }
}
